import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_DESPESASGERAIS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(itemDespesaId) {
        return axiosJwt
            .get(`${api}/despesasgerais/finalizacao/itensdespesas/${itemDespesaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItens(idsItensDto) {
        return axiosJwt
            .post(`${api}/despesasgerais/finalizacao/itensdespesas/obteritens`, idsItensDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}